import styled from 'styled-components';
import Particles from "@tsparticles/react";

export const mainContainer = styled.div`
    display: grid;
    place-items: center;
    width: 100vw;
    height: 100dvh;
    margin: 0;
    padding: 0;
    background: linear-gradient(180deg, rgba(179,179,179,1) 0%, rgba(89,89,89,1) 100%);
`;
export const loginTitle = styled.h1`
    width: 80%;
    color: black;
    font-size: 35px;
    font-weight: 500;
    font-family: 'Georgia', sans-serif;
    margin-bottom: 50px;
    text-align: center;

    @media (max-width: 500px) {
        width: 70%;
        font-size: 25px;
        margin-top: 20px;
    }

    @media (max-width: 350px) {
        font-size: 20px;
    }
`;

export const loginTitleImage = styled.img`
    width: 80%;
    margin-bottom: 50px;
`;

export const loginContainer = styled.div`
    width: 400px;
    height: 450px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid white;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
    border-radius: 10px;
    z-index: 999;

    @media (max-width: 500px) {
        width: 350px;
        height: 400px;
    }

    @media (max-width: 350px) {
        width: 250px;
        height: 300px;
    }
`;
export const loginForm = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 95%;
    height: 95%;
    background-color: white;
    color: black;
    border-radius: 10px;

    @media (max-width: 500px) {
        width: 95%;
        height: 95%;
    }
`;
export const loginInput = styled.input`
    width: 80%;
    height: 40px;
    margin-bottom: 20px;
    border: none;
    border-radius: 5px;
    padding-left: 10px;
    font-size: 18px;
    font-family: 'Georgia', sans-serif;
    background-color: var(--palette-one-blue);
    color: white;

    &::placeholder {
        color: rgba(255,255,255,0.75);
    }

    &:focus {
        outline: none;
    }

    @media (max-width: 500px) {
        width: 80%;
    }
`;
export const loginButton = styled.button`
    width: 80%;
    height: 40px;
    margin-bottom: 20px;
    border: none;
    border-radius: 5px;
    background-color: var(--palette-one-blue);
    color: white;
    font-size: 18px;
    font-family: 'Georgia', sans-serif;
    cursor: pointer;

    @media (max-width: 500px) {
        width: 80%;
    }
`;
export const linksContainer = styled.div`
    width: 80%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 500px) {
        width: 70%;
    }
`;
export const loginLink = styled.a`
    color: black;
    font-size: 14px;
    font-family: 'Georgia', sans-serif;
    margin-bottom: 20px;
    cursor: pointer;

    @media (max-width: 500px) {
        font-size: 14px;
    }

    @media (max-width: 350px) {
        font-size: 10px;
    }
`;
export const particles = styled(Particles)`
    z-index: 0;
    position: absolute;
`;